import styled from 'react-emotion';

// eslint-disable-next-line import/prefer-default-export
export const CommentsContainer = styled.div`
  width: 100%;
`;
